/* src/app/components/user/ReviewsTabs/styles.js */

export default theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.default,
  },
  header: {
    height: theme.spacing.unit * 4,
  },
  contentOverride: {
    width: '100%',
  },
  detailRoot: {
    flexDirection: 'column',
  },
  headerText: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  withComment: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'hidden',
  },
  expanded: {
    border: `1px solid ${theme.palette.primary.main}`,
  },
  comment: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexGrow: 1,
  },
  textsContainer: {
    display: 'flex',
    flexDirction: 'column',
  },
});



// WEBPACK FOOTER //
// ./src/app/components/user/ReviewsTable/styles.js